module.exports = __webpack_public_path__ + "static/media/Residential_55.b5d768aa.jpg";